import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { GetMagicCardRulingsResponse, MagicCardRuling } from "@apiserver-rest/ponder-data-client-base";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { formatDate } from "@ponder-shared/utils/general";
import { take } from "rxjs";
import { MagicMarkdownPipe } from "../markdown/magic-markdown.pipe";

@Component({
    selector: "magic-card-rulings",
    imports: [LoadingComponent, NgClass, MagicMarkdownPipe],
    templateUrl: "./magic-card-rulings.component.html"
})
export class MagicCardRulingsComponent {
    @Input({ required: true }) public oracleId!: string;

    public readonly initialMax: number = 3;
    public showAll: boolean = false;

    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;
    public rulings: MagicCardRuling[] = [];

    constructor(private ponderDataClient: PonderDataClient) {

    }

    public ngOnInit(): void {
        this.ponderDataClient
            .magicCardRulings(this.oracleId)
            .pipe(take(1))
            .subscribe({
                next: (response: GetMagicCardRulingsResponse) => {
                    if (response.success) {
                        this.rulings = response.rulings ?? this.rulings;
                        this.loadingSuccess = true;
                    }
                }
            })
            .add(() => { this.isLoading = false; })
    }

    public getDateStr(ruling: MagicCardRuling): string {
        return formatDate(ruling.date);
    }

    public onShowAllClicked(): void {
        this.showAll = true;
    }
}